import { useLocation } from 'react-router-dom';
import { useBanner } from '@/hooks/useBanner';
import { useCurrentPerson } from '@/hooks/useCurrentPerson';
import { useStorageProtection } from '@/hooks/useStorageProtection';
import { isAuthRoute, STORAGE_UNPROTECTED_MESSAGE } from './messages';

/**
 * Posts the general "install to keep your offline work safe" warning while the
 * browser may delete the device's offline data on its own, whether or not
 * anything is waiting to upload.
 *
 * Storage counts as protected when the app is installed — Safari keeps Home
 * Screen apps out of its 7-day deletion and Chrome grants installed apps
 * persistent storage — or when the browser granted persistent storage to the
 * tab (Chrome, Firefox). Installed is enough on its own because Safari can
 * report persisted() as false even for a Home Screen app, and the user can do
 * nothing more about it.
 */
export function useStorageProtectionBanner(): void {
  const { persisted, installed, checked } = useStorageProtection();
  const { organizationId } = useCurrentPerson();
  const { pathname } = useLocation();
  const signedIn = organizationId !== null && !isAuthRoute(pathname);
  useBanner(checked && signedIn && !installed && persisted !== true ? STORAGE_UNPROTECTED_MESSAGE : null);
}
